export default "__VITE_ASSET__BlpIAIwy__"